import React, { createContext, useContext, useEffect, useRef, useState } from 'react'
import { Link, navigate } from 'gatsby'
import './halloween.css'

const NORMAL_LOGO = 'https://cdn.mercadodeflores.pe/mercado-de-flores.png'
const HALLOWEEN_LOGO = 'https://cdn.mercadodeflores.pe/mercado-de-flores-halloween.png'
const HalloweenContext = createContext({ active: false, celebrate: null })

export function isHalloween(date = new Date()) {
  const campaignDate = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'America/Lima', year: 'numeric', month: '2-digit'
  }).formatToParts(date)
  return campaignDate.find(part => part.type === 'year').value === '2026' &&
    campaignDate.find(part => part.type === 'month').value === '10'
}

export function BrandLink({ className, imageClassName, width = 144, height, linked = true }) {
  const { active, celebrate } = useContext(HalloweenContext)
  const Brand = linked ? Link : 'span'
  return (
    <Brand to={linked ? '/' : undefined} className={className} data-halloween-brand aria-label={linked ? 'Mercado de Flores, ir al inicio' : undefined}
      onClick={linked ? event => {
        if (!linked || !active || !celebrate || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
        event.preventDefault()
        celebrate(event.currentTarget)
      } : undefined}>
      <img src={active ? HALLOWEEN_LOGO : NORMAL_LOGO} alt="Mercado de Flores" width={width} height={height}
        className={imageClassName} onError={event => {
          if (event.currentTarget.getAttribute('src') !== NORMAL_LOGO) event.currentTarget.src = NORMAL_LOGO
        }} />
    </Brand>
  )
}

function Bouquet() {
  return (
    <g>
      <path d="M101 158 88 110m13 48 16-54m-16 54-1-61" stroke="#558b60" strokeWidth="5" strokeLinecap="round" />
      <path d="M100 144q-28-2-25-20 21-1 25 20m4-9q24-19 28-2-12 15-28 2" fill="#78a96e" />
      {[[86, 106, '#f4a8c3'], [117, 101, '#d5b6ef'], [100, 90, '#ffd699']].map(([x, y, color]) => (
        <g key={x} transform={`translate(${x} ${y})`} fill={color}>
          <circle cy="-8" r="9" /><circle cx="8" r="9" /><circle cy="8" r="9" /><circle cx="-8" r="9" />
          <circle r="5" fill="#fff4c7" />
        </g>
      ))}
      <path d="m90 143 21 0-8 23h-7Z" fill="#edd3b1" />
      <path d="M100 149c-19-13-19 7 0 2 19-13 19 7 0 0" fill="#ce83a5" />
    </g>
  )
}

export default function HalloweenProvider({ children }) {
  const [active, setActive] = useState(false)
  const [scene, setScene] = useState(null)
  const busy = useRef(false)
  const timer = useRef(null)
  const mounted = useRef(false)
  useEffect(() => {
    mounted.current = true
    const refresh = () => setActive(isHalloween())
    refresh()
    const calendar = setInterval(refresh, 60000)
    return () => { mounted.current = false; clearInterval(calendar); clearTimeout(timer.current) }
  }, [])

  const celebrate = async source => {
    if (busy.current) return
    busy.current = true
    const original = source.getBoundingClientRect()
    try {
      if (window.location.pathname !== '/') await navigate('/')
      if (!mounted.current) return
      const target = document.querySelector('[data-halloween-brand]')
      const rect = target?.getBoundingClientRect() || original
      setScene({ '--logo-x': `${rect.left + rect.width / 2 - window.innerWidth / 2}px`,
        '--logo-y': `${rect.top + rect.height / 2 - window.innerHeight / 2}px` })
      timer.current = setTimeout(() => { setScene(null); busy.current = false }, 2800)
    } catch (_) { busy.current = false }
  }

  return (
    <HalloweenContext.Provider value={{ active, celebrate }}>
      {children}
      {scene && <div className="halloween-scene" style={scene} aria-hidden="true">
        <div className="halloween-veil" />
        <div className="halloween-flight">
          <div className="halloween-boo">boo<span>♡</span></div>
          <svg className="halloween-ghost" viewBox="0 0 200 220" fill="none">
            <ellipse cx="100" cy="200" rx="51" ry="7" fill="#746383" opacity=".12" />
            <g className="halloween-bouquet-back" transform="translate(40 -24) rotate(18 100 130)"><Bouquet /></g>
            <path d="M45 105c0-78 110-78 110 0 0 39 15 57 10 74-3 12-18-8-29-1-15 17-22-7-36 1-16 15-23-8-36-1-14 10-23 13-24 0-2-19 5-39 5-73Z" fill="#fffdf9" stroke="#e7dfec" strokeWidth="2" />
            <ellipse cx="80" cy="102" rx="5" ry="7" fill="#55445e" /><ellipse cx="120" cy="102" rx="5" ry="7" fill="#55445e" />
            <ellipse cx="68" cy="116" rx="9" ry="5" fill="#f4bfd0" /><ellipse cx="132" cy="116" rx="9" ry="5" fill="#f4bfd0" />
            <path d="M93 116q7 9 14 0" stroke="#55445e" strokeWidth="3" strokeLinecap="round" />
            <g className="halloween-bouquet-front"><Bouquet /></g>
            <path d="M53 135q6 20 28 13m66-13q-6 20-28 13" stroke="#e7dfec" strokeWidth="3" strokeLinecap="round" />
          </svg>
        </div>
      </div>}
    </HalloweenContext.Provider>
  )
}
